<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="viii" class="page" id="pviii" role="doc-pagebreak"></span><span aria-label="ix" class="page" id="pix" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="toc"><a class="xref" href="#/chitugendhaft0008#pro">Prologue</a></p>
<p class="toc"><a class="xref" href="#/chitugendhaft0009#ch01"><b>1</b>   Idols</a></p>
<p class="toc"><a class="xref" href="#/chitugendhaft0010#ch02"><b>2</b>   Museums</a></p>
<p class="toc"><a class="xref" href="#/chitugendhaft0011#ch03"><b>3</b>   Videos</a></p>
<p class="toc"><a class="xref" href="#/chitugendhaft0012#coda">Coda</a></p>
<p class="tocbmf"><a class="xref" href="#/chitugendhaft0013#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chitugendhaft0014#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chitugendhaft0015#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chitugendhaft0016#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-tugendhaft-0007.vue?4be7894a